import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { DEFAULT_TIME } from "../../constants/input-entries-constants";
import { TalkhattabatConversationType } from "../../Types";
import getKhattabatStore from "../../stores/khattabat-stores";
import getCorePersonalStore from "../../stores/core/core-personal-store";

export const apiCallSendOneOOneMessage = async ({
  alkhattabaText,
  userID,
  conversationType
}: {
  alkhattabaText: string;
  userID: number;
  conversationType: TalkhattabatConversationType;
}): Promise<{
  data: { messageCurrentTime: string };
  status: string;
  code: Ti18nKeys;
}> => {
  const isAiMessage = getCorePersonalStore().isKhattabaAiAdmin.get();
  const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
  const userUUID = getKhattabatStore().getOneOOneUserUUID({
    userID,
    conversationType
  });

  const { status, data, et3Error } = await post<{
    messageCurrentTime: string;
  }>(`khattabat/sendOneOOneMsg`, {
    alkhattabaUUID,
    userUUID,
    userID,
    alkhattabaText,
    conversationType,
    isAiMessage
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { messageCurrentTime: DEFAULT_TIME },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { messageCurrentTime: DEFAULT_TIME },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
